import React from "react";
import { List, TextInput } from "@raketa-cms/raketa-cms";
import InputSection from "../common/InputSection";
import TooltipInput from "../common/TooltipInput";

const FeaturesInput = ({ value, onChange }) => (
  <InputSection title="Features">
    <TextInput
      label="Title"
      value={value.title}
      onChange={(title) => onChange({ ...value, title })}
    />

    <List
      label="Items"
      listItem={(settings, onChangeItem) => (
        <React.Fragment>
          <TextInput
            label="Value"
            value={settings.value}
            onChange={(value) => onChangeItem("value", value)}
          />

          <InputSection title="Tooltip">
            <TooltipInput
              value={settings.tooltip}
              onChange={(value) => onChangeItem("tooltip", value)}
            />
          </InputSection>
        </React.Fragment>
      )}
      items={value.items}
      template={{ value: "", tooltip: {} }}
      primaryField="value"
      onChangeList={(_list, newList) => onChange({ ...value, items: newList })}
    />
  </InputSection>
);

export default FeaturesInput;
